import Hero from "../Component/Hero";
import DownloadAppSection from "../../../Components/DownloadAppSection";
import PengajuanPinjaman from "../Component/PengajuanPinjaman";
import PersyaratanPinjaman from "../Component/PersyaratanPinjaman";
import React from "react";
import CardDokumenPendukung from "../Component/CardDokumenPendukung";
import Table from "../Component/Table";

function PinjamanKaryawan() {
    return (
        <>
            <div>
                <Hero
                    imageClass='pinjaman-karyawan'
                    title='Pinjaman Karyawan'
                    subTitle='P I N J A M A N &emsp;I N D I V I D U'
                    explanation='
                        Pinjaman karyawan adalah fasilitas pinjaman tanpa agunan untuk berbagai macam kebutuhan. Jangka waktu pinjaman hingga 2 tahun dan pembayaran angsuran dilakukan setiap bulan.'
                    buttonText='AJUKAN PINJAMAN'
                />
                <Table type='individu' title='pinjaman-karyawan'/>
                <PersyaratanPinjaman type='individu' product='pinjaman-karyawan'/>
                <CardDokumenPendukung type='individu' product='pinjaman-karyawan'/>
                <PengajuanPinjaman type='individu'/>
                <DownloadAppSection/>
            </div>
        </>
    );
}

export default PinjamanKaryawan;
